import { css } from "styled-system/css";
import { contentMaxWidth } from "./capacitor-app.css";

/** Shared max-width page padding for feature screens. */
export const pageContainerStyles = css({
  width: "100%",
  maxWidth: contentMaxWidth,
  marginInline: "auto",
  paddingInline: "md",
  paddingBottom: "xl",
});

/** Shared page header: title row with standard spacing down to the search/filter bar. */
export const pageHeaderStyleDef = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-end",
  paddingTop: { base: "md", md: "xxl" },
  marginBottom: { base: "0.875rem", md: "1.25rem" },
} as const;

export const pageHeaderStyles = css(pageHeaderStyleDef);

/** Shared compact search/filter input: icon + ghost input inside a bordered box. */
export const filterInputContainerStyles = css({
  flex: 1,
  minWidth: "120px",
  display: "flex",
  alignItems: "center",
  paddingInline: "sm",
  height: "2rem",
  backgroundColor: "bgBase100",
  borderRadius: "medium",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  transition: "all 200ms",
  _focusWithin: {
    borderColor: "primary",
  },
});

export const filterInputStyles = css({
  width: "100%",
  height: "100%",
  border: "none",
  outline: "none",
  fontWeight: "700",
  color: "textBase",
  backgroundColor: "transparent",
  fontSize: "sm",
  _placeholder: {
    color: "textBase/40",
  },
});

export const filterInputIconStyles = css({
  color: "textBase/40",
  marginRight: "sm",
  flexShrink: 0,
});

// Re-exports for callers that still import chrome styles from `#/app.css`.
export {
  appStyles,
  mainStyles,
  safeAreaTopStyles,
  safeAreaBottomStyles,
  containerStyles,
  contentMaxWidth,
  bottomBarContainerStyles,
  bottomBarInnerStyles,
  bottomBarItemStyles,
} from "./capacitor-app.css";
